export const scrollMemoPaths: Record<string, number | undefined> = {};
